import { UpdateContactInfoState } from './updateContactInfo.types'

const initialState: UpdateContactInfoState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
